import script from "./themeChangePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./themeChangePopup.vue?vue&type=script&setup=true&lang=ts"

import "./themeChangePopup.vue?vue&type=style&index=0&id=12106121&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12106121"]])

export default __exports__